import React from 'react';
import Modal, { ModalV2Props } from '@zola/zola-ui/src/components/Modal/ModalV2';
import ModalContent from '@zola/zola-ui/src/components/Modal/ModalContent';
import H from '@zola/zola-ui/src/typography/Headings';
import P from '@zola/zola-ui/src/typography/Paragraphs';
import T from '@zola/zola-ui/src/typography/Text';
import { BrandAppleIcon } from '@zola/zola-ui/src/components/SvgIconsV3/BrandApple';

import SeatingChartQrCodePreauth from 'public/static-preauth/images/SeatingChartLp/qr/preauth.svg';
import SeatingChartQrCodePostauth from 'public/static-preauth/images/SeatingChartLp/qr/postauth.svg';
import SeatingChartQrCode from 'public/static-preauth/images/SeatingChartLp/qr/default.svg';
import AppQrCodePreauth from 'public/static-preauth/images/AppLP/QRCodes/qr-code-preauth.png';
import AppQrCodePostauth from 'public/static-preauth/images/AppLP/QRCodes/qr-code-postauth.png';

import { ModalContainer, AppDownloadContainer, DownloadText } from './AppDownloadModal.styles';

type AppDownloadModalProps = {
  source?: 'SEATING_CHART_PREAUTH' | 'SEATING_CHART_POSTAUTH' | 'APP_PREAUTH' | 'APP_POSTAUTH';
  onClose: ModalV2Props['onClose'];
  triggerRef: ModalV2Props['triggerRef'];
};

const AppDownloadModal = ({ source, onClose, triggerRef }: AppDownloadModalProps): JSX.Element => {
  let campaign;
  let QrCode;

  switch (source) {
    case 'SEATING_CHART_PREAUTH':
      campaign = 'zola_web_seating_chart_lp_preauth';
      QrCode = SeatingChartQrCodePreauth;
      break;
    case 'SEATING_CHART_POSTAUTH':
      campaign = 'zola_web_seating_chart_lp_postauth';
      QrCode = SeatingChartQrCodePostauth;
      break;
    case 'APP_PREAUTH':
      campaign = 'zola_web_mobile_app_lp_preauth';
      QrCode = AppQrCodePreauth;
      break;
    case 'APP_POSTAUTH':
      campaign = 'zola_web_mobile_app_lp_postauth';
      QrCode = AppQrCodePostauth;
      break;
    default:
      campaign = 'zola_web_seating_chart_lp';
      QrCode = SeatingChartQrCode;
      break;
  }

  const isSeatingChart = source === 'SEATING_CHART_PREAUTH' || source === 'SEATING_CHART_POSTAUTH';
  const hed = isSeatingChart ? 'Create your seating chart' : 'Download the app';

  return (
    <Modal
      dialogHeadingId="pricing-breakdown"
      onClose={onClose}
      rootId="portal-root"
      triggerRef={triggerRef}
      lockBgScrolling
    >
      <ModalContent>
        <ModalContainer>
          <H.TitleMedium3>{hed}</H.TitleMedium3>
          {isSeatingChart && <P.BodyBase>Available exclusively in our iOS app</P.BodyBase>}
          <AppDownloadContainer
            href={`https://apps.apple.com/app/apple-store/id852691916?pt=31209800&ct=${campaign}&mt=8`}
            noTextTransform
            noUnderline
            target="_blank"
            rel="noopener noreferrer"
          >
            <DownloadText>
              <P.BodyBase>
                <T.Strong>Download Zola Weddings</T.Strong>
              </P.BodyBase>
              <P.BodySmall color="BLACK_050">
                <BrandAppleIcon height={24} width={24} css={{ verticalAlign: 'bottom' }} />
                Available on iOS
              </P.BodySmall>
            </DownloadText>
            <img src={QrCode} height="120" width={120} alt="Download the Zola Weddings app" />
          </AppDownloadContainer>
        </ModalContainer>
      </ModalContent>
    </Modal>
  );
};

export default AppDownloadModal;
